import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LEADENGINEERAPIConstant } from '../constants/leadengineer.constant';
import { AppConfigService } from './base/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LeadEngineerService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;
  
  private completeApprovalResponse: any = null;
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }
  constructor(private http: HttpClient) {
  }
  
  
  getAllData() {
    const facilityId = this.getCurrentFacilityId();

    return (
      this.http.get<any>(`${this.apiBaseUrl}${LEADENGINEERAPIConstant.getAll}?facilityId=${facilityId}`) )
  }

  getRightData() {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${LEADENGINEERAPIConstant.getByCAI}?facilityId=${facilityId}`) )
  }

  getAssignedData(tagNumber : any) {
    const facilityId = this.getCurrentFacilityId();
    return (
      this.http.get<any>(`${this.apiBaseUrl}${LEADENGINEERAPIConstant.getAssignedDetails}?facilityId=${facilityId}&tagNumber=${tagNumber}`) )
  }

  updateAssignedData(payload: any) {
    return this.http.put<any>(`${this.apiBaseUrl}${LEADENGINEERAPIConstant.Update}`,payload);
  }

  saveAssignedData(payload: any) {
    return this.http.post<any>(`${this.apiBaseUrl}${LEADENGINEERAPIConstant.Save}`, payload);
  }

}

